module.exports = __webpack_public_path__ + "static/media/sittingicon_lg.0e07b522.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/sittingicon_lg.png
 ** module id = 297
 ** module chunks = 0
 **/